import { use } from 'react'
import { CompanyBillingContext } from '@/components/company-billing/context'

export const useCompanyBilling = () => {
  const {
    remainingCredits,
    hasCompany,
    hasValidBankcard,
    hasPaymentMethod,
    hasBillingDetails,
    isInsolvent,
  } = use(CompanyBillingContext)
  return {
    remainingCredits,
    hasCompany,
    hasValidBankcard,
    hasPaymentMethod,
    hasBillingDetails,
    isInsolvent,
  }
}
